var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn-toggle',{attrs:{"tile":"","group":"","mandatory":""},model:{value:(_vm.emailDivider),callback:function ($$v) {_vm.emailDivider=$$v},expression:"emailDivider"}},[_c('v-btn',{attrs:{"small":"","value":"comma"}},[_vm._v(" Komma ")]),_c('v-btn',{attrs:{"small":"","value":"semicolon"}},[_vm._v(" Semikolon ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }